module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./PublicWelfareView.js"));
	}, "PublicWelfareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PublicWelfareView!./src/pages/Shop/Home/Carnival/commonweal/PublicWelfare/PublicWelfareView.js
// module id = 929
// module chunks = 438